import { mobileLargeBreakpoint } from "../../../constants/breakpoints";

export default class {
    constructor(context) {
        this.context = context;
        this.responsiveClass = 'TravelPlanner-responsive';
        this.containerClass = 'container';
        this.init();
    }

    init() {    
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                if (entry.contentBoxSize) {
                    this.handleElementSizeChanged();
                }
            }
        });

        resizeObserver.observe(this.context);        
    }

    handleElementSizeChanged = () => {
        const parentElement = this.context.parentElement;
        const isInMainBody = parentElement.classList.contains('body-content');
        const width = this.context.clientWidth;
        if (width < mobileLargeBreakpoint) {
            this.context.classList.add(this.responsiveClass);
            if (!isInMainBody) {
                this.context.classList.remove(this.containerClass);
            }
        } else {
            this.context.classList.remove(this.responsiveClass);
            if (!isInMainBody) {
                this.context.classList.add(this.containerClass);
            }
        }
    }
}